export default __webpack_public_path__ + "static/media/hero-entekhab.414e6a04.png";